
import React, { useEffect, useRef } from "react";
import { Container, Placeholder } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import uniqid from 'uniqid';

import ScrollButtons from './ScrollButtons';
import MoreGamesLink from "./MoreGamesLink";
import getImageSrc from "../utils/get-image-src";
import CategoryTitle from "./CategoryTitle";

export default function GamesRowColumns({ categoryURL }) {
    const country = useSelector((state) => state.globalContent.data.country)
    const categories = useSelector((state) => state.gameCategories.list || null);
    const category = categories ? (categories[`${categoryURL}-${country.ISOcode}`] || categories[categoryURL]) : null;

    const placeholder = new Array(4).fill(null);
    const container = useRef(null);

    useEffect(() => { }, [categories]);

    return (
        <section className="game-category-container section-margin" >
            <Container fluid="lg" className="game-row-container">
                {/* {
                    category ? <h2 className="h3 mb-3">{category?.title}</h2> : (
                        <Placeholder as="h3" animation="glow">
                            <Placeholder xs={12} style={{ width: "170px", borderRadius: "10px" }} />
                        </Placeholder>
                    )
                } */}
                <CategoryTitle title={category?.title} />

                <div className="position-relative">
                    <div className="games-row-columns-wrapper" ref={container}>
                        {
                            !category ?
                                placeholder.map((category, i) =>
                                    <GameColumn subCategoryURL={category} key={uniqid()} />
                                ) :
                                category?.categories.map((item, i) =>
                                    <GameColumn
                                        subCategoryURL={item.url}
                                        categoryURL={categoryURL}
                                        key={uniqid()}
                                    />
                                )
                        }
                        {/* More games link */}
                        {/* <MoreGamesLink centered={true} /> */}
                    </div>

                    {/* Scroll */}
                    <ScrollButtons container={container} />
                </div>

            </Container>
        </section>
    );
}

function GameColumn({ subCategoryURL }) {
    const country = useSelector((state) => state.globalContent.data.country)
    const categories = useSelector((state) => state.gameCategories.list || null);
    const category = categories ? (categories[`${subCategoryURL}-${country.ISOcode}`] || categories[subCategoryURL]) : null;
    const placeholder = new Array(6).fill(null);

    return (
        <div className="game-column">
            <div className="game-column-top-row">
                <h3 className="subtitle white-87">{category?.title}</h3>
                <div className="">
                    <Link to={`games`} className={`btn-secondary`}>View all</Link>
                </div>
            </div>

            {
                !category ?
                    placeholder.map((game, i) =>
                        <GameTile game={game} key={uniqid()} />
                    ) :
                    category.games.slice(0, 3).map((game, i) =>
                        <GameTile game={game} key={uniqid()} />
                    )
            }
            {/* <div className="mt-4 pb-2">
                <Link to={`games`} className={`btn-secondary-outline`}>View all</Link>
            </div> */}
        </div>
    )
}

function GameTile({ game }) {
    const locale = useSelector((state) => state.globalContent.data.locale);
    const userLoggedIn = useSelector((state) => state.user.isLoggedIn);

    if (!game) {
        return (
            <Placeholder as="div" animation="glow">
                <Placeholder xs={12} className="game-column-wrapper-placeholder" />
            </Placeholder>
        )
    }

    return (
        <Link to={`${userLoggedIn ? `/${locale}/game/${game.id}` : `?register&game=${game.id}` }`} className="game-column-wrapper">
            <div className="game-column-image-wrapper">
                <div className="game-column-image-cover" style={{ backgroundImage: `url(${getImageSrc(game.image)}` }}></div>
                <img className="game-column-image" src={getImageSrc(game.image)} alt={game.name} />
            </div>
            <div className="game-column-text">
                <div>
                    <p className="game-column-text-title">{game.name}</p>
                    <p className="game-column-text-provider">{game.provider}</p>
                </div>
            </div>
            {
                game.tags.toLowerCase().includes('live') && (
                    <div className="tag-container-right">
                        <span className="img-live" ></span>
                        <span className="tag-name">Live</span>
                    </div>
                )
            }
        </Link>
    )
}